var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('modals.lead.deleteTitle'),"action":"delete","on-submit":_vm.submit,"on-close":_vm.close}},[_c('div',{staticClass:"mb-2"},[_vm._v(" "+_vm._s(_vm.$t('modals.lead.deleteText'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }